import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useSWUpdate } from '../hooks/useSWUpdate';
import { Button } from './ui/button';

/**
 * Shows a non-intrusive notification when a new app version is available.
 * User can click to reload and get the latest version.
 */
const UpdateNotification = () => {
  const { hasUpdate, applyUpdate } = useSWUpdate();

  if (!hasUpdate) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9997] bg-[#0F2C3E] text-white rounded-xl shadow-2xl px-5 py-3 flex items-center gap-3 animate-in slide-in-from-bottom duration-500"
      role="alert"
      data-testid="update-notification"
    >
      <RefreshCw className="h-4 w-4 text-[#D4A017] shrink-0" />
      <span className="text-sm">A new version is available</span>
      <Button
        size="sm"
        onClick={applyUpdate}
        className="bg-[#D4A017] hover:bg-[#c4920f] text-[#0F2C3E] font-semibold text-xs ml-1"
        data-testid="update-notification-btn"
      >
        Update
      </Button>
    </div>
  );
};

export default UpdateNotification;
